import { useEffect, useRef, type VideoHTMLAttributes } from 'react'

/** A selected slide owns its stream; removing it stops playback and buffering. */
export default function SelectedVideo({ src, ...props }: VideoHTMLAttributes<HTMLVideoElement> & { src: string }) {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = ref.current
    if (!video) return
    video.src = src
    if (props.autoPlay) void video.play().catch(() => { /* Browser autoplay policy may require a tap. */ })
    return () => {
      video.pause()
      video.removeAttribute('src')
      video.load()
    }
  }, [src, props.autoPlay])

  return <video ref={ref} {...props} />
}
